import React, { FC } from 'react';
import { SVG } from "./SVG";

export const DropdownCollapseIcon: FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <SVG {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" isIcon>
        <g id="ri:arrow-drop-down-fill">
            <path d="M12 14L8 10H16L12 14Z" fill="#232329"/>
        </g>
    </SVG>
);